function useWindowBreakpoints() {
  return {
    xs: 320,
    sm: 361,
    md: 768,
    lg: 992,
    xl: 1366,
    '2xl': 1920,
  };
}

export { useWindowBreakpoints };
